/* eslint-disable formatjs/no-literal-string-in-jsx */
import { useEffect, useState } from "react";
import { Dialog } from "../../../../common/core-ui/Dialog.tsx";
import useUserPreference from "../../actions/user/useUserPreference.ts";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import useFractionPersistValue, {
  FractionPersistKey,
} from "../../../../common/core-ui/useFractionPersistValue.ts";
import TextInput from "../../../../common/core-ui/TextInput.tsx";
import { usePromotionActivate } from "../../actions/explore-promotion/usePromotionActivate.tsx";
import { usePromotionReturn } from "../../actions/explore-promotion/usePromotionReturn.tsx";

function DebugButton(props: React.ComponentPropsWithoutRef<"button">) {
  return (
    <button
      {...props}
      className="vst-button-rectangle vst-button-variant-outline"
      style={{ ...{ width: "100%" }, ...props.style }}
    />
  );
}

function ResetPreferenceButton({
  preferenceKey,
  ...buttonProps
}: React.ComponentPropsWithoutRef<"button"> & {
  preferenceKey: UserPreferenceKey;
}) {
  const [_value, _update, reset] = useUserPreference(preferenceKey);

  return <DebugButton {...buttonProps} onClick={() => reset()} />;
}

function PromotionsTest() {
  const [vbid, setVbid] = useState("");
  const { activatePromotion } = usePromotionActivate(vbid);
  const { returnPromotion } = usePromotionReturn(vbid);
  return (
    <>
      <div style={{ display: "flex", paddingTop: 16 }}>
        <TextInput
          labelText={"vbid (Promotions testing)"}
          type="text"
          value={vbid}
          onChange={(event) => setVbid(event.target.value)}
        />
        <DebugButton
          style={{ width: "auto", alignSelf: "end", marginLeft: "4px" }}
          onClick={() => {
            activatePromotion();
          }}
        >
          Activate
        </DebugButton>
        <DebugButton
          style={{ width: "auto", alignSelf: "end", marginLeft: "4px" }}
          onClick={() => {
            returnPromotion();
          }}
        >
          Deactivate
        </DebugButton>
      </div>
    </>
  );
}

export default function DebugDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const [_explorePromoVal, setExplorePromoVal] = useFractionPersistValue(
    FractionPersistKey.SubscriptionPopoverStatus
  );

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.code === "KeyD" && e.altKey) {
        setIsOpen(true);
      }
    };

    window.addEventListener("keyup", listener);
    return () => {
      window.removeEventListener("keyup", listener);
    };
  }, []);

  if (isOpen) {
    return (
      <Dialog
        title="Debug Menu"
        darkHeader
        onRequestClose={() => setIsOpen(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.DashboardOnboardingBannerDismissed}
          >
            Reset Dashboard Banner
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={
              UserPreferenceKey.DashboardRecommendationsBannerDismissed
            }
          >
            Reset Dashboard Recommendations Banner
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.MyLibraryOnboardingBannerDismissed}
          >
            Reset Library Banner
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.ExpiredOnboardingBannerDismissed}
          >
            Reset Expired Banner
          </ResetPreferenceButton>
          <DebugButton
            onClick={() => {
              setExplorePromoVal(null);
            }}
          >
            Reset Explore Promo Box
          </DebugButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.HomeSearchHistory}
          >
            Reset Search History
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.LastSeenExpiredAt}
          >
            Reset Last Seen Expired At
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.MyCoursesUserSurveyDismissedDate}
          >
            Reset My Courses Survey Toast
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.LastSeenRecommendations}
          >
            Reset Last Seen Recommendations
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.RecommendationsLive}
          >
            Reset Recommendations New Feature
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={
              UserPreferenceKey.MyCoursesVerifyShippingAddressExpiredOn
            }
          >
            Reset My Courses Verify Shipping Address
          </ResetPreferenceButton>
          <ResetPreferenceButton
            preferenceKey={UserPreferenceKey.DashboardNewNavBannerDismissed}
          >
            Reset Dashboard New Nav Banner Dismissed
          </ResetPreferenceButton>
        </div>
        <PromotionsTest />
      </Dialog>
    );
  }
}
